<div class="page-layout carded fullwidth inner-scroll">
  <div class="center">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h1" [translate]="'LOCATIONS_GROUPS.TITLE'"> Location </span>

      <div class="page-buttons" fxHide.xs>
        <button
          mat-stroked-button
          [disabled]="!hasCreateLocationGroupPermission"
          matTooltip="{{ 'LOCATIONS_GROUPS.ADD' | translate }}"
          (click)="openDialog()"
        >
          <i
            matTooltipPosition="left"
            class="angularjs-fuse-icon icon-plus"
            [matTooltip]="'LOCATIONS_GROUPS.PERMISSIONS.NO_CREATE' | translate"
            [matTooltipDisabled]="hasCreateLocationGroupPermission"
          ></i>
        </button>

        <button
          *ngIf="filtered"
          mat-stroked-button
          matTooltip="{{ 'LOCATIONS_GROUPS.FILTER_CLEAR' | translate }}"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>

        <button
          mat-stroked-button
          matTooltip="{{ 'LOCATIONS_GROUPS.FILTER' | translate }}"
          (click)="toggleSidebarOpen('filterLocations')"
        >
          <i class="angularjs-fuse-icon icon-filter"></i>
        </button>

        <button mat-stroked-button matTooltip="{{ 'LOCATIONS_GROUPS.RELOAD' | translate }}" (click)="reload()">
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>
      </div>

      <div class="page-buttons" fxShow="false" fxShow.xs>
        <button mat-stroked-button [matMenuTriggerFor]="menuLocationsGroups">
          <mat-icon class="accent-500-fg">keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menuLocationsGroups>
          <button
            [disabled]="!hasCreateLocationGroupPermission"
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="openDialog()"
          >
            <i class="angularjs-fuse-icon icon-plus mr-4"></i>
            <span [translate]="'LOCATIONS_GROUPS.ADD'">Add</span>
          </button>

          <button *ngIf="filtered" mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="clearFilters()">
            <i class="angularjs-fuse-icon icon-filter-remove mr-4"></i>
            <span [translate]="'LOCATIONS_GROUPS.FILTER_CLEAR'">Clear filter</span>
          </button>

          <button
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="toggleSidebarOpen('filterLocations')"
          >
            <i class="angularjs-fuse-icon icon-filter mr-4"></i>
            <span [translate]="'LOCATIONS_GROUPS.FILTER'">Filter</span>
          </button>

          <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="reload()">
            <i class="angularjs-fuse-icon icon-reload small mr-4"></i>
            <span [translate]="'LOCATIONS_GROUPS.RELOAD'">Reload</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="content-card datatable">
      <mat-table
        #datatable
        class="datatable__table"
        [dataSource]="locationsGroups"
        fusePerfectScrollbar
        matSort
        [matSortDisableClear]="true"
      >
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="35">
            {{ 'LOCATIONS_GROUPS.HEADER.NAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let locationGroup" fxFlex="35" fxFlex.xs="100">
            <span class="mobile-label">{{ 'LOCATIONS_GROUPS.HEADER.NAME' | translate }}</span>
            <div
              class="label-color"
              [class.red-500-bg]="locationGroup.archived"
              [class.green-500-bg]="!locationGroup.archived"
            ></div>
            <span class="limit-cells" [matTooltip]="locationGroup.name" [matTooltipShowDelay]="500">
              {{ locationGroup.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef fxFlex="38">
            {{ 'LOCATIONS_GROUPS.HEADER.DESCRIPTION' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let locationGroup" fxFlex="38" fxFlex.xs="100">
            <span class="mobile-label">{{ 'LOCATIONS_GROUPS.HEADER.DESCRIPTION' | translate }}</span>
            <span
              class="limit-cells"
              [matTooltip]="locationGroup.description"
              [matTooltipDisabled]="!locationGroup.description"
              [matTooltipShowDelay]="500"
            >
              {{ locationGroup.description || '-' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="20">
            {{ 'LOCATIONS_GROUPS.HEADER.CREATED_AT' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let locationGroup" fxFlex="20" fxFlex.xs="100">
            <span class="mobile-label">{{ 'LOCATIONS_GROUPS.HEADER.CREATED_AT' | translate }}</span>
            <span
              class="limit-cells"
              [matTooltip]="locationGroup.createdAt | date: 'dd/MM/yyyy HH:mm'"
              [matTooltipShowDelay]="500"
            >
              {{ locationGroup.createdAt | date: 'dd/MM/yyyy HH:mm' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef fxFlex="7">
            {{ 'LOCATIONS_GROUPS.HEADER.ACTIONS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let locationGroup" fxFlex="7" fxFlex.xs="100" fxLayoutAlign.xs="center center">
            <span class="mobile-label uppercase">{{ 'LOCATIONS_GROUPS.EDIT' | translate }}</span>
            <button
              mat-icon-button
              matTooltip="{{
                (hasEditLocationGroupPermission ? 'LOCATIONS_GROUPS.EDIT' : 'LOCATIONS_GROUPS.VIEW') | translate
              }}"
              (click)="openDialog(locationGroup.id)"
            >
              <img src="assets/images/icons/new_icon_edit_action.svg" alt="edit locations group" />
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
          <mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="displayedColumns.length"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            {{ 'LOCATIONS_GROUPS.NO_DATA' | translate }}
          </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="loading">
          <mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="displayedColumns.length"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            <div class="p-24" fxLayout="column" fxLayoutAlign="center center">
              <mat-spinner color="primary" diameter="64" class="mb-24"></mat-spinner>
              {{ 'LOCATIONS_GROUPS.LOADING' | translate }}
            </div>
          </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" [class.display-none]="loading"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [hidden]="loading || locationsGroups?.length"></mat-footer-row>
        <mat-footer-row *matFooterRowDef="['loading']" [hidden]="!loading"></mat-footer-row>
      </mat-table>
      <mat-paginator [length]="totalCount" [pageSizeOptions]="[25, 50, 100, 200, 250]"></mat-paginator>
    </div>
  </div>
</div>

<fuse-sidebar name="filterLocations" key="filterLocationsGroups" position="right" lockedOpen="true">
  <filters-locations-groups class="sidebar-filter"></filters-locations-groups>
</fuse-sidebar>
